import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { apiConstants } from "../../common/constants";
import { decodeAuthToken } from "../../helpers/UtilityHelper";
import { login, loginUserDataSlice } from "../../redux/userSlice";
import { fetchReportData } from "../../redux/actions/reportAction";
import { useSnackbar } from "notistack";
import Loader from "../../common/Loader";

export default function HandleMSALRedirect() {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");

        if (code) {
            exchangeCodeForToken(code);
        }
    }, []);


    const appLoginLogic = async (response) => {
        setIsLoading(true);
        try {
            let config = { headers: { 'Content-Type': 'application/json' } };
            const validateURL = `${apiConstants.BASE_LOCAL}${apiConstants.VALIDATE_MSAL_AUTH_CODE}`;
            const { data } = await axios.post(validateURL,
                {
                    "idToken": response?.id_token,
                    "panel": "MERCHANT"
                }
            );
            localStorage.setItem('userToken', data.accessToken);
            if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
            const { merchantOid, merchantList, roles, switchableMerchantOids } = decodeAuthToken(data.accessToken);

            dispatch(loginUserDataSlice({ ...data }))
            const hasSwitchableMerchants = Array.isArray(switchableMerchantOids) && switchableMerchantOids.length > 0;
            if (hasSwitchableMerchants || (roles?.includes('ROLE_PROSHIPADMIN') && (merchantList === undefined || merchantList?.length === 0 || merchantList?.length > 0))) {
                let url = "/loginuser";
                navigate(url);
            } else {
                let merchantData;
                config = {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + data.accessToken,
                    },
                };
                let merchantUrl =
                    apiConstants.BASE_LOCAL + apiConstants.GET_MERCHANT_SEARCH;
                const val = await axios.post(
                    merchantUrl,
                    {
                        offset: 0,
                        limit: 1,
                        orfilter: [],
                        andfilter: [{ field: "id", operator: "eq", value: merchantOid }],
                        excludes: "mappedOrderRule,sla",
                    },
                    config
                );
                merchantData = val?.data.data[0];
                delete merchantData.mappedOrderRule;
                delete merchantData.wallet;
                delete merchantData.pickup_details;
                delete merchantData.bank_details;
                delete merchantData.alertSubscription;
                delete merchantData.gstDetails;
                delete merchantData.merchantWebHooks;
                delete merchantData.activeSlas;
                delete merchantData.alertSubscriptionB2B;
                const userInfo = { ...data, merchant: merchantData };
                dispatch(login(userInfo));
                dispatch(fetchReportData(merchantOid));
            }
        } catch (error) {
            navigate("/unAuthorized");
            enqueueSnackbar(error?.response?.data?.message || "Something went wrong", { variant: "error" });
            console.error("Token exchange failed:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const exchangeCodeForToken = async (code) => {
        try {
            const code_verifier = localStorage.getItem("ms_code_verifier");
            const data = {
                client_id: process.env.REACT_APP_MSAL_CLIENT_ID,
                grant_type: "authorization_code",
                code: code,
                redirect_uri: process.env.REACT_APP_MSAL_REDIRECT_URI,
                code_verifier: code_verifier,
                scope: "openid profile email User.Read offline_access"
            };
            const response = await axios.post(
                "https://login.microsoftonline.com/common/oauth2/v2.0/token",
                new URLSearchParams(data),
                {
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                }
            );
            if (response.status === 200) {
                appLoginLogic(response.data);
            }
        } catch (error) {
            navigate("/unAuthorized");
            console.error("Token exchange failed:", error?.message || "Something went wrong");
        }
    };

    return (
        <>
            {isLoading && (
                <Loader />
            )}
        </>
    )
}